var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3013_5529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 23.2261L22.7739 20.0076L17.2266 16.7734V23.2261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866564 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0ZM30.5263 23.5395C30.5267 24.0626 30.4239 24.5806 30.224 25.064C30.0241 25.5473 29.7308 25.9866 29.3611 26.3566C28.9913 26.7266 28.5523 27.0201 28.069 27.2204C27.5858 27.4206 27.0678 27.5237 26.5447 27.5237H13.4553C12.9322 27.5237 12.4142 27.4206 11.931 27.2204C11.4477 27.0201 11.0087 26.7266 10.6389 26.3566C10.2692 25.9866 9.97596 25.5473 9.77602 25.064C9.57608 24.5806 9.47335 24.0626 9.47369 23.5395V16.4605C9.47335 15.9374 9.57608 15.4194 9.77602 14.936C9.97596 14.4527 10.2692 14.0134 10.6389 13.6434C11.0087 13.2734 11.4477 12.9799 11.931 12.7796C12.4142 12.5794 12.9322 12.4763 13.4553 12.4763H26.5447C27.0678 12.4763 27.5858 12.5794 28.069 12.7796C28.5523 12.9799 28.9913 13.2734 29.3611 13.6434C29.7308 14.0134 30.0241 14.4527 30.224 14.936C30.4239 15.4194 30.5267 15.9374 30.5263 16.4605V23.5395Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3013_5529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.4561797d9b84adfa10aafab1a0b025ac.svg";
export { ForwardRef as ReactComponent };